import { useSmartProp, useEditor } from '@smartfire/wordpress-react';
import {
  MediaPlaceholder,
  MediaUploadCheck,
  MediaUpload,
} from '@wordpress/block-editor';
import React from 'react';
import style from './style.module.scss';
import { Button, ButtonGroup, IconButton } from '@wordpress/components';

export default function EditableImg({
  smartProp,
  className = '',
  promptChangeText = "Changer l'image",
  ...props
}) {
  const [img, update] = useSmartProp(smartProp);
  const { isEditing } = useEditor();
  if (isEditing) {
    return (
      <div className={style.editableImg}>
        {img && img.url ? (
          <>
            <img className={className} src={img.url} alt={img.alt} {...props} />
            <div className={style.buttons}>
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={update}
                  allowedTypes={['image']}
                  value={img ? img.id : null}
                  render={({ open }) => (
                    <ButtonGroup>
                      <Button isDefault onClick={open}>
                        {promptChangeText}
                      </Button>
                      <IconButton
                        isDefault
                        isDestructive
                        icon="trash"
                        onClick={() => update(null)}
                      />
                    </ButtonGroup>
                  )}
                />
              </MediaUploadCheck>
            </div>
          </>
        ) : (
          <MediaUploadCheck>
            <MediaPlaceholder
              value={img && img.url ? img : {}}
              onSelect={update}
            />
          </MediaUploadCheck>
        )}
      </div>
    );
  } else {
    return (
      <img
        className={style.image + ' ' + className}
        src={img.url}
        alt={img.alt}
        {...props}
      />
    );
  }
}
